export const formatUtcToKoreanDate = (utcDateString) => {
  const date = new Date(utcDateString);

  // const kstDate = new Date(date.getTime() + 9 * 60 * 60 * 1000);
  const kstDate = new Date(date.getTime() * 60 * 60 * 1000);

  const year = kstDate.getFullYear();
  const month = String(kstDate.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작
  const day = String(kstDate.getDate()).padStart(2, "0");

  return `${year}.${month}.${day}`;
};

export const formatDate = (dateTimeString) => {
  const [datePart] = dateTimeString.split(" ");
  const [year, month, day] = datePart.split("-");
  return `${year}.${month}.${day}`;
};
